import {
  BANNER_DATA,
  BANNER_RESET,
  SCREEN_READER_DATA_RESET,
  SCREEN_READER_DATA,
} from '../../actionTypes/Notifications/Notifications';

const initialNotificationsState = {
  banners: {
    current: [],
    past: [],
  },
  srAttributes: {
    ariaLabel: '',
    ariaLabelledby: '',
    ariaDescribedby: '',
    text: '',
  },
};

export default function notificationsReducer(state = initialNotificationsState, action) {
  switch (action.type) {
    case BANNER_DATA:
      return { ...state, banners: action.payload };
    case BANNER_RESET:
      return { ...state, banners: { ...initialNotificationsState.banners } };
    case SCREEN_READER_DATA:
      return { ...state, srAttributes: { ...initialNotificationsState.srAttributes, ...action.payload } };
    case SCREEN_READER_DATA_RESET:
      return { ...state, srAttributes: { ...initialNotificationsState.srAttributes } };
    default:
      return state;
  }
}
